module.exports = __webpack_public_path__ + "img/adesivagem_vidro3.4a9f35aa.jpg";